import { render } from "./ConcursAdauga.vue?vue&type=template&id=24d710da"
import script from "./ConcursAdauga.vue?vue&type=script&lang=js"
export * from "./ConcursAdauga.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__